import { KS_CONTACT, kshetrapalDeveloper, buildFaqs } from "./developer";

const G = "https://shreekshetrapal.in/storage/2026/05";

const evana = {
    slug: "shree-kshetrapal-evana",
    visibility: "public",
    name: "Shree Kshetrapal Evana",
    tagline: "Premium Commercial · Aeroplane Circle",
    category: "commercial",
    typeLabel: "Commercial",
    areaLabel: null,
    city: "Bhuj",
    citySlug: "bhuj",
    locality: "Mundra Road",
    status: "Under Construction",
    priceLabel: null,
    developer: { name: "Shree Kshetrapal Infra LLP" },
    whatsapp: KS_CONTACT.whatsapp,
    phone: KS_CONTACT.phone,
    phoneDisplay: KS_CONTACT.phoneDisplay,
    coverImage: "https://shreekshetrapal.in/storage/2025/04/evana-slider.webp",
    hero: {
        image: "https://shreekshetrapal.in/storage/2025/04/evana-slider.webp",
        overline: "Commercial · Mundra Road, Bhuj",
        lines: ["Shree Kshetrapal", "Evana"],
        sub: "A premium commercial development on Mundra Road, Bhuj — contemporary infrastructure and well-planned commercial spaces with excellent connectivity.",
    },
    sections: [
        {
            type: "overview",
            overline: "Overview",
            title: "A modern business destination.",
            paragraphs: [
                "Shree Kshetrapal Evana is a premium commercial development thoughtfully designed to create a modern business destination.",
                "Strategically located on Mundra Road, Bhuj, it offers excellent connectivity, contemporary infrastructure and well-planned commercial spaces — an ideal choice for businesses, retail outlets, offices and investors looking for long-term growth and value.",
            ],
            facts: [
                { label: "Status", value: "Under Construction" },
                { label: "Type", value: "Commercial" },
                {
                    label: "Address",
                    value: "Near Aeroplane Circle, Mundra Road, Bhuj",
                },
            ],
        },
        {
            type: "highlights",
            overline: "Highlights",
            title: "Why Evana.",
            items: [
                {
                    title: "Near Aeroplane Circle",
                    text: "A recognised landmark location on Mundra Road, Bhuj.",
                },
                {
                    title: "Modern business destination",
                    text: "Contemporary infrastructure and well-planned commercial spaces.",
                },
                {
                    title: "Excellent connectivity",
                    text: "Positioned on one of Bhuj's principal corridors.",
                },
                {
                    title: "2 dedicated elevators",
                    text: "Smooth vertical movement for visitors and tenants.",
                },
                {
                    title: "Popular brands & stores",
                    text: "Planned as a destination with recognised brands and stores.",
                },
                {
                    title: "For businesses & investors",
                    text: "Suited to retail, offices and long-term investment.",
                },
            ],
        },
        {
            type: "amenities",
            overline: "Amenities",
            title: "Designed for business comfort.",
            note: "Amenity list as published by the developer.",
            items: [
                { icon: "Video", name: "CCTV Surveillance", desc: "Camera coverage across the development." },
                { icon: "Car", name: "Car Parking", desc: "Parking for tenants and visitors." },
                { icon: "ArrowUpDown", name: "2 Dedicated Elevators", desc: "Fast vertical access." },
                { icon: "Cross", name: "Hospital Access", desc: "Hospital facility in the vicinity." },
                { icon: "Droplets", name: "Water Facilities", desc: "Planned water supply infrastructure." },
                { icon: "ShieldCheck", name: "24/7 Security System", desc: "Round-the-clock security." },
                { icon: "Store", name: "Popular Brands & Stores", desc: "Planned retail destination mix." },
                { icon: "Flame", name: "Fire Safety", desc: "Fire-safety systems as per plan." },
            ],
        },
        {
            type: "plans",
            overline: "Floor Plans",
            title: "Three levels of retail & office space.",
            note: "Plans as published by the developer. Tap any plan to view it full size.",
            items: [
                {
                    label: "Ground Floor",
                    image: "https://shreekshetrapal.in/storage/2026/07/ground-floor-2.webp",
                },
                {
                    label: "First Floor",
                    image: "https://shreekshetrapal.in/storage/2026/07/first-floor-2.webp",
                },
                {
                    label: "Second Floor",
                    image: "https://shreekshetrapal.in/storage/2026/07/second-floor-2.webp",
                },
            ],
        },
        {
            type: "gallery",
            overline: "Gallery",
            title: "Evana in renders.",
            caption: "Imagery courtesy of Shree Kshetrapal Infra LLP.",
            images: [
                { src: `${G}/gallery_8_1x.webp`, caption: "Elevation render", span: 8 },
                { src: `${G}/gallery_7_1x.webp`, caption: "Architectural render", span: 4 },
                { src: `${G}/gallery_6_1x.webp`, caption: "Architectural render", span: 4 },
                { src: `${G}/gallery_5__1x.webp`, caption: "Architectural render", span: 4 },
                { src: `${G}/gallery_3_1x.webp`, caption: "Architectural render", span: 4 },
                { src: `${G}/gallery_2_1x.webp`, caption: "Architectural render", span: 4 },
            ],
        },
        {
            type: "location",
            overline: "Location",
            title: "Near Aeroplane Circle, Mundra Road.",
            addressLines: ["Near Aeroplane Circle,", "Mundra Road, Bhuj, Gujarat"],
            mapUrl: "https://maps.app.goo.gl/UnQFQHgC5UbcLQoL6",
            landmarks: [
                { name: "Jubilee Ground", detail: "1.8 km" },
                { name: "Bhuj Bus Station", detail: "3.2 km" },
                { name: "Bhuj Railway Station", detail: "4.9 km" },
                { name: "Bhuj Airport", detail: "8.9 km" },
            ],
            note: "Distances as published by the developer.",
        },
        { type: "developer", ...kshetrapalDeveloper },
        buildFaqs("Shree Kshetrapal Evana"),
        {
            type: "cta",
            overline: "Connect Directly",
            title: "Talk to the Evana team.",
            text: "Ask for current pricing, unit availability, payment plans or a site visit — your message goes straight to Shree Kshetrapal Infra LLP. No brokers in between.",
            brochureUrl:
                "https://shreekshetrapal.in/storage/2026/07/SHREE-KSHETRAPAL-EVANA.pdf",
        },
    ],
};

export default evana;
